/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Order_By_LabelInputs */

const en_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order By`)
};

const fr_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier par`)
};

const de_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren nach`)
};

const it_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina per`)
};

const ru_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать по`)
};

const es_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const zh_cn2_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const ja_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替え`)
};

const hi_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्वारा आदेश`)
};

const pt_pt2_merge_event_group_order_by_label = /** @type {(inputs: Merge_Event_Group_Order_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

/**
* | output |
* | --- |
* | "Order By" |
*
* @param {Merge_Event_Group_Order_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_order_by_label = /** @type {((inputs?: Merge_Event_Group_Order_By_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Order_By_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_order_by_label(inputs)
	if (locale === "de") return de_merge_event_group_order_by_label(inputs)
	if (locale === "it") return it_merge_event_group_order_by_label(inputs)
	if (locale === "ru") return ru_merge_event_group_order_by_label(inputs)
	if (locale === "es") return es_merge_event_group_order_by_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_order_by_label(inputs)
	if (locale === "ja") return ja_merge_event_group_order_by_label(inputs)
	if (locale === "hi") return hi_merge_event_group_order_by_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_order_by_label(inputs)
	return en_merge_event_group_order_by_label(inputs)
});